// Single source of truth for hidden personalised invitation pages.
// Add new guests by dropping their HTML in /public and adding a row here.
// `slug` is the tracking key (lower-case) used for open/view tracking.
export const GUEST_INVITES = [
  {
    slug: "siandtish",
    guest: "Simon & Tish",
    type: "Full day",
    paths: ["/SiandTish", "/siandtish"],
    src: "/SiandTish.html",
    title: "Rebecca & Tom — Invitation for Simon & Tish",
  },
  {
    slug: "pennyandroddy",
    guest: "Penny & Roddy",
    type: "Evening",
    paths: ["/PennyAndRoddy", "/pennyandroddy"],
    src: "/PennyAndRoddy.html",
    title: "Rebecca & Tom — Evening Invitation for Penny & Roddy",
  },
  {
    slug: "tomselway",
    guest: "Tom & Clare",
    type: "Full day",
    paths: ["/TomSelway", "/tomselway"],
    src: "/TomSelway.html",
    title: "Rebecca & Tom — Invitation for Tom & Clare",
  },
  {
    slug: "jamiesiggers",
    guest: "Jamie Siggers",
    type: "Full day",
    paths: ["/JamieSiggers", "/jamiesiggers"],
    src: "/JamieSiggers.html",
    title: "Rebecca & Tom — Invitation for Jamie Siggers",
  },
  {
    slug: "jamesanddebbie",
    guest: "James & Debbie",
    type: "Evening",
    paths: ["/JamesandDebbie", "/jamesanddebbie", "/JamesAndDebbie"],
    src: "/JamesandDebbie.html",
    title: "Rebecca & Tom — Evening Invitation for James & Debbie",
  },
];
